export default __webpack_public_path__ + "static/media/undraw_relaxation_1_wbr7.81f25723.svg";